export default __webpack_public_path__ + "static/media/expl-dissect_13_DE.267e7f1e.png";